import wacType from '../type/wac';
import quoteGQLString from '../util/quoteGQLString';

export default (orgId) => `
    wacsByOrg (org: ${quoteGQLString(orgId)}){
        ${wacType()}
    }
`;
